import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Cars from './pages/Cars';
import CarDetail from './pages/CarDetail';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Reservations from './pages/Reservations';
import ReservationDetail from './pages/ReservationDetail';
import ReservationCalendar from './pages/ReservationCalendar';
import Insurance from './pages/Insurance';
import Payments from './pages/Payments';
import Reports from './pages/Reports';

import Documents from './pages/Documents';
import Blacklist from './pages/Blacklist';
import GlobalBlacklistAccess from './pages/GlobalBlacklistAccess';
import GpsAccessControl from './pages/GpsAccessControl';
import GpsTracking from './pages/GpsTracking';
import DamageReports from './pages/DamageReports';
import BackupManagement from './pages/BackupManagement';

import AgencyInfo from './pages/AgencyInfo';
import AgencyUpdateRequests from './pages/AgencyUpdateRequests';
import Users from './pages/Users';
import LoadingSpinner from './components/LoadingSpinner';
import ProtectedRoute from './components/ProtectedRoute';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const App = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="cars" element={<Cars />} />
          <Route path="cars/:id" element={<CarDetail />} />
          <Route path="clients" element={<Clients />} />
          <Route path="clients/:id" element={<ClientDetail />} />
          <Route path="reservations" element={<Reservations />} />
          <Route path="reservations/:id" element={<ReservationDetail />} />
          <Route path="calendar" element={<ReservationCalendar />} />
          <Route path="insurance" element={<Insurance />} />
          <Route path="payments" element={<Payments />} />
          <Route path="reports" element={<Reports />} />

          <Route path="documents" element={<Documents />} />
          <Route path="blacklist" element={<Blacklist />} />
          <Route path="global-blacklist-access" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <GlobalBlacklistAccess />
            </ProtectedRoute>
          } />
          <Route path="gps-access-control" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <GpsAccessControl />
            </ProtectedRoute>
          } />
          <Route path="gps-tracking" element={<GpsTracking />} />
          <Route path="damage-reports" element={<DamageReports />} />

          <Route path="agency-info" element={<AgencyInfo />} />
          <Route path="agency-update-requests" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <AgencyUpdateRequests />
            </ProtectedRoute>
          } />
          <Route path="users" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <Users />
            </ProtectedRoute>
          } />
          <Route path="backup" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <BackupManagement />
            </ProtectedRoute>
          } />
        </Route>
      </Routes>
    </div>
  );
};

export default App; 